import { MySphLightboxHelper } from "@sphtech/web2-core/auth";
import { PublicationShortname } from "@src/app/auth/serviceIdentifier";
import cx from "classnames";
import type { ReactElement } from "react";
import logoutIcon from "src/app/assets/icons/logout.svg";
import { getCookiePath } from "src/app/auth/cookiePath";
import { clearLoginSession, clearSessionID, COOKIE_MYSPH_SID } from "src/trackers/viewerContext";
import Cookies from "js-cookie";

import styles from "./index.module.scss";

type Props = {
  theme: PublicationShortname;
  handleLogout: () => void;
};

export default function LogoutButton({
  theme,
  handleLogout,
}: Props): ReactElement {
  const getPostLogoutUrl = () => window.location.href;

  const onLogout = () => {
    const mysphSid = Cookies.get(COOKIE_MYSPH_SID);
    clearSessionID(mysphSid);
    MySphLightboxHelper.openLogout({
      getPostLogoutUrl,
      getCookiePath,
    });
    clearLoginSession(theme);
    handleLogout();
  };

  return (
    <button
      className={cx(styles.logoutButton)}
      onClick={onLogout}
      data-theme={theme}
    >
      <img src={logoutIcon} alt="logout icon" />
    </button>
  );
}
